

import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";


/// GET IP  ADDRESS
const responseip = await fetch("https://api.ipify.org?format=json");
const data = await responseip.json();
const ip = data.ip;
export const IP=ip + "";

// set Date FORMAT
export const DATE_FORMAT = 'DD-MMM-YYYY';


//SET copyrights

export function Copyright(props) {
    return (
      <Typography variant="body2" color="textSecondary" align="center" {...props}>
        {"Copyright © "}
        <Link color="inherit" href="https://sriyansh.co.in">
          Sriyansh Computers, Gorakhpur
        </Link>{" "}
        {new Date().getFullYear()}
        {"."}
      </Typography>
    );
  }
  

  //SET developers
  export function Developer(props) {
    return (
      <Typography variant="body2" color="textSecondary" align="center" {...props}>
        {"Software Developed by "}
        <Link color="inherit" href="https://sriyansh.co.in">
          Sriyansh Computers
        </Link>{" "}
      </Typography>
    );
  }
  

  export const USER_RIGHTS = {
    SUPER_ADMIN:0,
    ADMIN: 1,
    ENTRY_USER: 2,
    MIS_USER:3,
    
}